import { mergeUndeliveredActivity } from '../operationAudit/auditOutbox';
import { TRPCClient } from '../utils/apiClient';

export type TemplateOperationActivityEntry = {
  invocationId: string;
  source: 'ui' | 'webmcp';
  toolName: string | null;
  operation: string;
  outcome: string;
  completedAt: string;
  auditStatus: 'acknowledged' | 'pending' | 'failed';
  workingRevision: number | null;
  errorCode: string | null;
};

export type TemplateOperationActivityPage = {
  entries: TemplateOperationActivityEntry[];
  nextCursor: string | null;
};

type ListOperationActivityClient = {
  listOperationActivity: {
    query: (input: {
      templateId: string;
      limit?: number;
      cursor?: string;
    }) => Promise<TemplateOperationActivityPage>;
  };
};

const OBJECT_ID_PATTERN = /^[0-9a-fA-F]{24}$/;

export async function fetchTemplateOperationActivity(
  templateId: string,
  options: { limit?: number; cursor?: string } = {},
): Promise<TemplateOperationActivityPage> {
  if (!OBJECT_ID_PATTERN.test(templateId)) {
    return { entries: [], nextCursor: null };
  }

  const page = await (
    TRPCClient.client.adTemplate as unknown as ListOperationActivityClient
  ).listOperationActivity.query({
    templateId,
    limit: options.limit,
    cursor: options.cursor,
  });
  return mergeUndeliveredActivity(templateId, page, options.cursor);
}
